import { Skeleton } from "@/components/ui/skeleton";

export const LoadingAppCard = () => {
  return <Skeleton data-testid="loadingAppCard" className="h-40 rounded" />;
};
